// extracted by mini-css-extract-plugin
module.exports = {"container":"PersonalNav_container__3UHAV","item":"PersonalNav_item__1WaEq"};